import { TweenMax, Power3 } from "gsap/TweenMax";




export default class Counter {

    constructor() {
        this.elCounter = document.querySelector(".js-counter");
    }


    // get amount of planted trees from the API
    getTrees() {
        const API_BASE = 'https://script.google.com/a/anywhere.co/macros/s/AKfycbxuyeR7-ONawDyLbfwf0CKyhYmCdZ3Y9oTXJ6ogoz4zHXLKsTI/exec';
        const API_KEY  = 'Be_the_Change';
        const url      = `${API_BASE}?key=${API_KEY}`;
         
        fetch(url)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error('Trees Counter: Network response error');
            })
            .then((json) => {
                let respObj = JSON.parse(json);
                const trees = respObj.status !== 'success' ? this.estimateTrees() : respObj.data[0][0];
                this.setTrees('' + trees);
            })
            .then(()=>{ 
                if (this.elCounter.classList.contains('aos-animate')) {
                    this.runAnim();
                } 
            })
            .catch((error) => {
                const estimate = this.estimateTrees();
                this.setTrees(estimate);
                console.log(error.message);
            });
    }


    // estimate amount of planted trees
    estimateTrees() {
        const start = new Date(2018, 10); // Nov 2018
        const now   = new Date();
        const treesPlanted = Math.floor((now.getTime() - start.getTime()) / 2629800000) * 9220;

        return '' + treesPlanted || this.elNumber.textContent;
    }


    // set amount of planted trees
    setTrees(amount) {
        const times = Math.max(5, amount.length);

        this.elNumber.innerHTML = `${amount.split("").map((item, i) => this.formatTreesNumber(item, i, times)).join("")}`;

        this.setSize(times);
    }


    formatTreesNumber(nbr, idx, length) {
        const place = length - 1 - idx;

        return `<span><span>0</span><span>${nbr}</span></span>${(place !== 0 && place % 3 === 0) ? "<span><span>,</span></span>" : ""}`;
    }


    // set numbers sizing
    setSize(times = 5) {
        this.elNumH = this.elNumber.clientHeight / 2;
        this.elNumW = Math.ceil(this.elNumber.clientWidth / times);

        this.elNumber.style.height = `${this.elNumH}px`;
        this.elNumber.style.width = `${this.elNumW * times}px`;
    }


    // set counter animation
    setAnim() {
        TweenMax.set(this.elTrees, { yPercent: '100%' });
        TweenMax.set(this.elNumber, { visibility: 'visible' });
    }


    // run counter animation
    runAnim() {
        const numbers = this.elNumber.childNodes;

        TweenMax.killTweensOf([numbers, this.elTrees]);
        TweenMax.staggerTo(numbers, 0.6, {
            y: this.elNumH * -1,
            ease: Power3.easeOut,
            delay: 0.1
        }, -0.2
        );
        TweenMax.staggerTo(this.elTrees, 0.8, {
            yPercent: 0,
            ease: Power3.easeOut,
        }, 0.2
        );
    }


    // initialiaze counter
    init() {
        if (!this.elCounter) return;

        this.elNumber = this.elCounter.querySelector(".js-counter-number");
        this.elTrees  = this.elCounter.querySelectorAll(".js-counter-tree");

        this.elCounter.classList.add("is-counter-init");

        if (typeof window.fetch === 'function') {
            this.getTrees();
        } else {
            const estimate = this.estimateTrees();
            this.setTrees(estimate);
        }

        this.setAnim();
        this.bind();
    }

    
    bind() {
      document.addEventListener('aos:in:runTreesCounter', () => { this.runAnim(); });
    }
}


// WEBPACK FOOTER //
// ./src/js/components/counter.js